import React, { useContext, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../contexts';


export const HomeContext = React.createContext(null);

const { Provider } = HomeContext;

export const HomeProvider = (props) => {


    return (
        <Provider value={{
        }}>
            {props.children}
        </Provider>
    );
}